import AbstractEntity from "./abstractEntity";

/*
divisionSeasonObj properties:
  - abbr
  - colors
  - division (id)
  - id
  - league (id)
  - name
  - numTeams
  - season
  - teams (teamId[])
 */
class DivisionSeason extends AbstractEntity {
  /**
   *
   * @param {object} divisionSeasonObj
   * @param {UserInfo} userInfo
   */
  // constructor(divisionSeasonObj, userInfo) {
  //   super(divisionSeasonObj, userInfo);
  // }

  /**
   *
   * @returns {object}
   */
  getDivisionObj() {
    return this.userInfo.getDivisionObj(this.obj.division);
  }

  /**
   *
   * @returns {object}
   */
  getLeagueObj() {
    return this.userInfo.getLeagueObj(this.obj.league);
  }

  /**
   *
   * @param {TeamCollection} leagueSeasonTeams
   * @returns {Team[]}
   */
  getTeams(leagueSeasonTeams) {
    /** @type {Team[]} */
    let teams = leagueSeasonTeams.items.filter((team) =>
      this.obj.teams.includes(team.obj.id)
    );

    teams.sort((a, b) => {
      if (a.fullName === b.fullName) return 0;
      return a.fullName < b.fullName ? -1 : 1;
    });

    return teams;
  }
}

export default DivisionSeason;
